import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { stockControlStatesFormat } from "../../models/StockControlEntity";
import stockControlService from "../../services/stockControlService";
import { Clear, Replace } from "../../stores/stockControls/actions";
import useQueryString from "../queryString/useQueryString";

const useStockControls = () => {
    const { stockControls, totalPage } = useSelector(state => state.stockControls_data);
    const { search, setParameterSearch, filters, clearFilters } = useQueryString({ pageSize: 10, pageNumber: 1 });
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => dispatch(Clear())
    }, [dispatch])

    useEffect(() => {
        const searchStockControls = async () => {
            setLoading(true);
            await stockControlService
                .Search(search)
                .then(res => dispatch(Replace(res.values.map(stockControl => ({
                    ...stockControl,
                    stateToShow: stockControlStatesFormat[stockControl.state]
                })), res.totalResults, res.totalPage)))
                .finally(() => setLoading(false));
        }

        searchStockControls();
    }, [dispatch, search])

    return {
        stockControls,
        loading,
        totalPage,
        filters,
        clearFilters,
        setParameterSearch
    }
}

export default useStockControls;